// export const TOLLOGO = '/image/TOLLOGO_RB.png';
// export const SPINNING_MAN = '/image/SPINNING_MAN.png';
// export const BG_MAIN = '/image/BG.png';
export const ARC_IMG1 = require('./image/ARC_CUSTOMISATION_NEWAA.png');
export const ARC_IMG2 = require('./image/ARC_BLUR.jpg');
export const BIORE_IMG = require('./image/BIORE.png');
export const IMAGE_CIRCLES = require('./image/CIRCLES.png')
